import * as React from 'react'
import NumberFormat from 'react-number-format';
import { GDataContext } from '../GDataContext';

const ZeroBaseFeeChannelPercentage: React.FC = ({ }) => {
    const graphContext = React.useContext(GDataContext);
    const [percentage, setPercentage] = React.useState<number>(0);


    React.useEffect(() => {
        if (!graphContext.dataset) {
            return;
        }
        const zeroFeeEdges = graphContext.dataset.edges.filter(e => e.baseFeeMsat === 0);
        const percent = zeroFeeEdges.length / graphContext.dataset.edges.length;
        const rounded = Math.round(percent * 10000) / 100;
        setPercentage(rounded);

    }, [graphContext.dataset]);


    return (
        <div className="flex flex-col items-center pt-6" >
            <div className="text-4xl">
                {percentage}%
            </div>
            <div className="text-gray-500">
                Channels with #zeroBaseFee
            </div>
        </div>
    );
}

export default ZeroBaseFeeChannelPercentage;

